import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 150 153",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
			fill: "#F5F9FA"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_d_590_55820)",
			children: [/* @__PURE__ */ _jsx("mask", {
				id: "mask0_590_55820",
				style: { maskType: "alpha" },
				maskUnits: "userSpaceOnUse",
				x: 0,
				y: 0,
				width: 150,
				height: 150,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
					fill: "#2F616E"
				})
			}), /* @__PURE__ */ _jsx("g", {
				mask: "url(#mask0_590_55820)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M118 43H32C29.2386 43 27 45.2386 27 48V153C27 155.761 29.2386 158 32 158H118C120.761 158 123 155.761 123 153V48C123 45.2386 120.761 43 118 43Z",
					fill: "white"
				})
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66 53H40C38.3431 53 37 54.3431 37 56C37 57.6569 38.3431 59 40 59H66C67.6569 59 69 57.6569 69 56C69 54.3431 67.6569 53 66 53Z",
			fill: "#C4E0E2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66 95H40C38.3431 95 37 96.3431 37 98C37 99.6569 38.3431 101 40 101H66C67.6569 101 69 99.6569 69 98C69 96.3431 67.6569 95 66 95Z",
			fill: "#A8D8DE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M108 68H42C39.7909 68 38 69.7909 38 72V82C38 84.2091 39.7909 86 42 86H108C110.209 86 112 84.2091 112 82V72C112 69.7909 110.209 68 108 68Z",
			stroke: "#A8D8DE",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M108 109H42C39.2386 109 37 111.239 37 114V122C37 124.761 39.2386 127 42 127H108C110.761 127 113 124.761 113 122V114C113 111.239 110.761 109 108 109Z",
			fill: "#C4E0E2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M53 32C55.2091 32 57 30.2091 57 28C57 25.7909 55.2091 24 53 24C50.7909 24 49 25.7909 49 28C49 30.2091 50.7909 32 53 32Z",
			fill: "#C4E0E2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75 32C77.2091 32 79 30.2091 79 28C79 25.7909 77.2091 24 75 24C72.7909 24 71 25.7909 71 28C71 30.2091 72.7909 32 75 32Z",
			fill: "#0C5661"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M97 32C99.2091 32 101 30.2091 101 28C101 25.7909 99.2091 24 97 24C94.7909 24 93 25.7909 93 28C93 30.2091 94.7909 32 97 32Z",
			fill: "#C4E0E2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86 88C88.7614 88 91 85.7614 91 83C91 80.2386 88.7614 78 86 78C83.2386 78 81 80.2386 81 83C81 85.7614 83.2386 88 86 88Z",
			fill: "#C4E0E2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.9071 104.37C89.1071 104.37 88.3601 104.37 87.6801 104.327C86.8425 104.27 86.0367 103.984 85.3515 103.499C84.6662 103.014 84.128 102.349 83.7961 101.578L79.5771 93.2399C79.2676 92.8796 79.1131 92.4116 79.1472 91.9379C79.1813 91.4642 79.4012 91.0232 79.7591 90.7109C80.0522 90.4753 80.418 90.3484 80.7941 90.3519C81.071 90.3599 81.3428 90.428 81.5909 90.5512C81.839 90.6745 82.0574 90.8501 82.2311 91.0659L84.1471 93.6809L84.1761 93.7149V83.7799C84.1761 83.287 84.3719 82.8143 84.7204 82.4657C85.069 82.1172 85.5417 81.9214 86.0346 81.9214C86.5275 81.9214 87.0002 82.1172 87.3487 82.4657C87.6973 82.8143 87.8931 83.287 87.8931 83.7799V90.2799C87.8715 90.0407 87.9 89.7996 87.9767 89.5721C88.0534 89.3445 88.1767 89.1354 88.3387 88.9581C88.5007 88.7808 88.6979 88.6392 88.9176 88.5424C89.1374 88.4455 89.3749 88.3955 89.6151 88.3955C89.8552 88.3955 90.0928 88.4455 90.3125 88.5424C90.5323 88.6392 90.7294 88.7808 90.8914 88.9581C91.0534 89.1354 91.1767 89.3445 91.2535 89.5721C91.3302 89.7996 91.3587 90.0407 91.3371 90.2799V91.6349C91.3155 91.3957 91.344 91.1546 91.4207 90.9271C91.4974 90.6995 91.6207 90.4904 91.7827 90.3131C91.9447 90.1358 92.1419 89.9942 92.3616 89.8974C92.5814 89.8005 92.8189 89.7505 93.0591 89.7505C93.2992 89.7505 93.5368 89.8005 93.7565 89.8974C93.9763 89.9942 94.1734 90.1358 94.3354 90.3131C94.4974 90.4904 94.6207 90.6995 94.6975 90.9271C94.7742 91.1546 94.8027 91.3957 94.7811 91.6349V92.6789C94.7595 92.4397 94.788 92.1986 94.8647 91.9711C94.9414 91.7435 95.0647 91.5344 95.2267 91.3571C95.3887 91.1798 95.5859 91.0382 95.8056 90.9414C96.0254 90.8445 96.2629 90.7945 96.5031 90.7945C96.7432 90.7945 96.9808 90.8445 97.2005 90.9414C97.4203 91.0382 97.6174 91.1798 97.7794 91.3571C97.9414 91.5344 98.0647 91.7435 98.1415 91.9711C98.2182 92.1986 98.2467 92.4397 98.2251 92.6789V99.0159C98.1911 100.965 97.3101 104.251 94.2111 104.251C93.9861 104.261 92.0801 104.371 89.9111 104.371L89.9071 104.37Z",
			fill: "#0C5661",
			stroke: "white"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_590_55820",
			x: 21,
			y: 34,
			width: 108,
			height: 119,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: -3 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_590_55820"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_590_55820",
					result: "shape"
				})
			]
		}) })
	]
});
export default SvgEmptyLight;
